import { mapData } from '@/utilities/DataMapping';
import { Utils } from '@/utilities/Utils';

export interface IBookingAllocationDateVM {
    id: string;
    guid: string;
    allocationID: number;
    profileID: number;
    dateAssigned: boolean;
    dateInPast: boolean;
    latestCheckIn: Date;
    assignedToAnotherBooking: boolean;
    assignedToBookingText: string;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    allocatedDate: Date;
}

export class BookingAllocationDateVM implements IBookingAllocationDateVM {

    constructor(data?: IBookingAllocationDateVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingAllocationDateVM) {
        mapData(data, {
            root: () => this
        });
    }

    id: string = "";
    guid: string = Utils.emptyGuidValue;
    allocationID: number = 0;
    profileID: number = 0;
    dateAssigned: boolean = false;
    dateInPast: boolean = false;
    latestCheckIn: Date = new Date(Utils.emptyDateValue);
    assignedToAnotherBooking: boolean = false;
    assignedToBookingText: string = "";
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
    allocatedDate: Date = new Date(Utils.emptyDateValue);

    get latestCheckInTime() {
        if (this.latestCheckIn == null) { this.latestCheckIn = new Date(); }
        const hours = this.latestCheckIn.getHours().toString().length > 1 ? this.latestCheckIn.getHours() : "0" + this.latestCheckIn.getHours();
        const mins = this.latestCheckIn.getMinutes().toString().length > 1 ? this.latestCheckIn.getMinutes() : "0" + this.latestCheckIn.getMinutes();
        return hours + ":" + mins;
    }

    set latestCheckInTime(val: string) {

        const parts = val.split(":");
        const time = new Date();

        time.setHours(+parts[0]);
        time.setMinutes(+parts[1]);
        time.setSeconds(0);

        this.latestCheckIn = time;
    }
}